import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LanguageSelector } from "./language-selector";
import { useAuth } from "@/hooks/useAuth";
import { LogOut, User } from "lucide-react";

interface NavigationHeaderProps {
  className?: string;
}

export function NavigationHeader({ className = "sticky top-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border" }: NavigationHeaderProps) {
  const { user, userProfile, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <div className={`${className} px-4 py-3`}>
      <div className="container mx-auto flex items-center justify-between gap-4">
        {/* Navigation Menu */}
        <nav className="flex items-center gap-4 sm:gap-6">
          <Link to="/" className="text-foreground hover:text-primary transition-colors font-medium text-sm">
            Inicio
          </Link>
          <Link to="/presupuesto-personalizado" className="text-foreground hover:text-primary transition-colors font-medium text-sm whitespace-nowrap">
            Presupuesto
          </Link>
          <Link to="/reservar-cita" className="text-foreground hover:text-primary transition-colors font-medium text-sm whitespace-nowrap">
            Reservar Cita
          </Link>
        </nav>
        
        <div className="flex items-center gap-2 flex-shrink-0">
          <LanguageSelector />
        
          {user ? (
            // Usuario logueado - mostrar nombre como botón al portal y logout
            <div className="flex items-center gap-1 sm:gap-2">
              <Link to="/portal">
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="hover:bg-background hover:text-foreground hover:border-border text-xs sm:text-sm px-2 sm:px-3 min-w-0 max-w-[120px] sm:max-w-[160px]"
                >
                  <User className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2 flex-shrink-0" />
                  <span className="truncate">
                    {userProfile?.full_name || 
                     (user.user_metadata?.full_name) || 
                     user.email?.split('@')[0] || 
                     'Usuario'}
                  </span>
                </Button>
              </Link>
              <Button 
                variant="ghost" 
                size="sm"
                onClick={handleSignOut}
                className="hover:bg-destructive hover:text-destructive-foreground p-1 sm:p-2 min-w-0"
              >
                <LogOut className="h-3 w-3 sm:h-4 sm:w-4" />
              </Button>
            </div>
          ) : (
            // Usuario no logueado - mostrar botón de login
            <Link to="/auth">
              <Button 
                variant="outline" 
                size="sm"
                className="hover:bg-background hover:text-foreground hover:border-border text-xs sm:text-sm px-2 sm:px-3"
              >
                Login
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}